import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const SubscriptionFunctionalityIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg height={size} viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.599609 3.20078C0.599609 1.90078 1.64961 0.800781 2.99961 0.800781H14.1996C15.4996 0.800781 16.5996 1.90078 16.5996 3.20078V9.60078C16.5996 10.9508 15.4996 12.0008 14.1996 12.0008H2.99961C1.64961 12.0008 0.599609 10.9508 0.599609 9.60078V3.20078ZM19.7996 3.20078C19.7996 1.90078 20.8496 0.800781 22.1996 0.800781H26.9996C28.2996 0.800781 29.3996 1.90078 29.3996 3.20078V16.0008C29.3996 17.3508 28.2996 18.4008 26.9996 18.4008H22.1996C20.8496 18.4008 19.7996 17.3508 19.7996 16.0008V3.20078ZM14.9996 14.4008C16.2996 14.4008 17.3996 15.5008 17.3996 16.8008V20.8008C17.3996 22.1508 16.2996 23.2008 14.9996 23.2008H6.19961C4.84961 23.2008 3.79961 22.1508 3.79961 20.8008V16.8008C3.79961 15.5008 4.84961 14.4008 6.19961 14.4008H14.9996Z"
        fill={fill || color}
      />
    </svg>
  )
}
